import { render, staticRenderFns } from "./21.vue?vue&type=template&id=3809aad5&scoped=true&"
import script from "./21.vue?vue&type=script&lang=js&"
export * from "./21.vue?vue&type=script&lang=js&"
import style0 from "./21.vue?vue&type=style&index=0&id=3809aad5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3809aad5",
  null
  
)

export default component.exports